import { SkyMeshItem } from './Sky';
import { CloudMeshItem } from './Cloud';
import { BoxMeshItem } from './Box';
import { SphereMeshItem } from './Sphere';
import { CylinderMeshItem } from './Cylinder';
import { TorusMeshItem } from './Torus';
import { PlaneMeshItem } from './Plane';
import { TetrahedronMeshItem } from './Tetrahedron';
import { TubeMeshItem } from './Tube';
import { PolyhedronMeshItem } from './Polyhedron';
import { OctahedronMeshItem } from './Octahedron';
import { DodecahedronMeshItem } from './Dodecahedron';
import { ExtrudeMeshItem } from './Extrude';
import { LatheMeshItem } from './Lathe';
import { CapsuleMeshItem } from './Capsule';

export const MeshDefinitions = {
  'mesh.sky': SkyMeshItem,
  'mesh.cloud': CloudMeshItem,
  'mesh.box': BoxMeshItem,
  'mesh.sphere': SphereMeshItem,
  'mesh.cylinder': CylinderMeshItem,
  'mesh.torus': TorusMeshItem,
  'mesh.plane': PlaneMeshItem,
  'mesh.tetrahedron': TetrahedronMeshItem,
  'mesh.tube': TubeMeshItem,
  'mesh.polyhedron': PolyhedronMeshItem,
  'mesh.octahedron': OctahedronMeshItem,
  'mesh.dodecahedron': DodecahedronMeshItem,
  'mesh.extrude': ExtrudeMeshItem,
  'mesh.lathe': LatheMeshItem,
  'mesh.capsule': CapsuleMeshItem
}; 